export default __webpack_public_path__ + "static/media/wwr-img.6e7fb5f2.webp";